<template>
  <div class="page_content module_page advisee_tracker instructor_advisee_tracker" aria-label="Advisee tracker detail page">
    <div class="row dashboard-row stream-section">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 advisee_sec">
        <div class="card">
          <div class="row">
            <div class="col-12">
              <div class="page-heading">
                <div class="row">
                  <div class="module_heading" role="heading" aria-level="1">
                    <div class="module_icon icon-student1"></div>
                    <label
                      v-if="isProspectiveStudent"
                      id="catalogTitle"
                      class="head_txt module_type_name ml-1 ace_sec_hd"
                      role="heading"
                      aria-label="Prospective Student Tracker">
                        {{ $tf('prospectiveStudentTracker') }}
                    </label>
                    <label
                      v-else
                      id="catalogTitle"
                      class="head_txt module_type_name ml-1 ace_sec_hd"
                      role="heading"
                      :aria-label="$tf('adviseeTrackerAria')">
                        {{ $tf('adviseeTracker') }}
                    </label>
                  </div>
                  <div class="toolbar-right advisor-search-section">
                    <div class="out-of-total-item ace_sec_txt" tabindex="0">{{start}}-{{end}} of {{total}}</div>
                    <div class="btn_container pagination_sty3">
                      <button type="button" class="btn btn_trans" @click="clickPrev()" :disabled="!showPrev" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                      <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
                      <button type="button" class="btn next btn_trans"  @click="clickNext()" :disabled="!showNext" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                    </div>
                    <div class="search-box-container">
                      <input type="text" class="input-search" placeholder="search by name" aria-label="search by name" v-model="name" v-on:keyup.enter="searchAdvisees">
                      <button type="button" class="btn btn_srh" @click="searchAdvisees" aria-label="search advisee">
                        <span class="ic_srh ic_search" aria-hidden="true"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="advisor-detail-container pg_list">
            <div id="userDetailsPopover" class="user-detail-popover"></div>
            <div v-if="advisees.length > 0">
              <div class="row list_row" v-for="advisee in advisees" :key="advisee.userId">
                <div class="col-xl-1 col-lg-2 col-md-1 col-sm-1 usr_pic" :id="advisee.userExternalId" tabindex="0">
                  <span class="icon ic6-user1"></span>
                </div>
                <div class="col-xl-10 col-lg-9 col-md-9 col-sm-11">

                  <div class="row">
                    <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12">

                      <div class="row">
                        <div class="col-xl-8 col-lg-7 col-md-7 col-sm-7">
                          <span class="block_row user_name ace_sec_hd" role="heading" :aria-label="advisee.userName">{{advisee.userName}}</span>
                          <b-popover ref="progressPopup" :target="advisee.userExternalId" triggers="hover" container="userDetailsPopover" v-if="showStudentPopover && advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0">
                            <template slot="title">
                              <div class="header-title">
                                <span class="icon icon-stream"></span>
                                <span class="entity-title" tabindex="0">{{ advisee.userName }} </span>
                              </div>
                            </template>
                            <div class="cont-section">
                              <div class="left-col">
                                <div class="icon-mentor"></div>
                              </div>
                              <div class="right-col">
                                <div class="content-row">
                                  <span class="left-info" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" tabindex="0">Major: {{advisee.adviseeSharedStreams[0].majorTitle}}</span>
                                  <span class="left-info" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" tabindex="0">Major Credits Completed: {{advisee.adviseeSharedStreams[0].majorCompletedCredit}}</span>
                                  <span class="left-info" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" tabindex="0">Major GPA: {{advisee.adviseeSharedStreams[0].majorGPA}}</span>
                                  <span class="heading" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" tabindex="0">Overall Credits Completed: {{advisee.adviseeSharedStreams[0].overallCompletedCredit}}</span><br/>
                                  <span class="heading" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" style="margin-top: 8px; float: left;" tabindex="0">Overall GPA: {{advisee.adviseeSharedStreams[0].overallGPA}}</span>
                                </div>
                              </div>
                            </div>
                          </b-popover>
                        </div>
                        <div class="col-xl-4 col-lg-5 col-md-5 col-sm-5">

                          <div class="channel_sec" v-if="isChannelEnabled">
                            <channel-unread-counter-tag v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" :externalId="advisee.adviseeSharedStreams[0].uuid"></channel-unread-counter-tag>
                          </div>

                          <!--<span class="ic ic9-notes"></span>-->
                        </div>
                      </div>

                    </div>

                    <div class="col-xl-7 col-lg-6 col-md-12 col-sm-12">
                      <div class="row">
                        <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12" v-if="isShowProgramName">
                          <div class="block_row program" style="margin-bottom: 10px;" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].majorTitle && advisee.adviseeSharedStreams[0].majorTitle.length > 0">
                            <!--<div class="col-1 block_label" tabindex="0">
                              {{majorLabel}}:
                            </div>-->
                            <div class="ic_container">
                              <span class="ic ic8-degree"></span>
                            </div>
                            <div class="block_val">{{advisee.adviseeSharedStreams[0].majorTitle}}</div>
                          </div>

                          <div class="block_row block_tp_row external_id" style="margin-bottom: 10px;" :aria-label="'External Id ' + advisee.userExternalId" v-if="isShowStudentExternalId">
                            <!--<div class="col-1 block_label"></div>-->
                            <div class="block_val" style="padding-left: 30px;">External Id: {{advisee.userExternalId}}</div>
                          </div>
                        </div>

                        <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12" v-if="isShowStudentEmail">
                          <div class="block_row user_email">
                            <div class="ic_container">
                              <span class="ic ic9-email"></span>
                            </div>
                            <div class="block_val" :title="advisee.userEmail" :aria-label="advisee.userEmail">{{advisee.userEmail}}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="block additional_info col-xl-6 col-lg-12 col-md-12 col-sm-12">
                      <div class="row">

                      </div>
                      <div class="block_row ace_sec_txt" style="margin-top: 8px;" v-if="isCocuricularVerificationFeature">
                        <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].coCurricularStatusMap">
                          <template v-if="advisee.adviseeSharedStreams[0].coCurricularStatusMap.total > 0">
                            <span>Co-curricular Verification Requests:</span> <br/>
                            <span>Total - {{advisee.adviseeSharedStreams[0].coCurricularStatusMap.total}}</span> /
                            <span style="cursor: pointer; color: #157099;" @click="goToTimeView(advisee.adviseeSharedStreams[0].uuid)">Pending - {{advisee.adviseeSharedStreams[0].coCurricularStatusMap.pending}}</span>
                          </template>
                          <template v-else>
                            <span>Co-curricular Verification Requests:</span> <br/>
                            <span>Total - 0</span> /
                            <span style="cursor: pointer; color: #157099;" @click="goToTimeView(advisee.adviseeSharedStreams[0].uuid)">Pending - 0</span>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-1 col-lg-2 col-md-2 col-sm-12">
                  <div class="row">
                    <div class="icon_container col-xl-12 col-lg-12 col-md-12 col-sm-12" v-if="!isProspectiveStudent" style="padding-left: 0px;">
                      <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0">
                        <template v-if="redirectStreamToProgressView">
                          <b-link class="view_plan btn" v-if="advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamProgress', params: { uuid: advisee.adviseeSharedStreams[0].uuid }}">
                            <span class="icon-stream"></span>
                            <span class="title">view plan</span>
                          </b-link>
                        </template>
                        <template v-else>
                          <b-link class="view_plan btn" v-if="advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamPlanner', params: { uuid: advisee.adviseeSharedStreams[0].uuid }}">
                            <span class="icon-stream"></span>
                            <span class="title">view plan</span>
                          </b-link>
                        </template>
                        <template v-if="isLockStreamEnabled">
                          <!-- TODO add unlocked icons and remove text 'locked/unlocked' -->
                          <b-link class="access_plan" v-if="isLocked(advisee.adviseeSharedStreams[0])" @click.stop.prevent="unlockStreamClicked(advisee.adviseeSharedStreams[0])">
                            <span class="ic ico-lock" style="margin-top: -5px;"></span>
                            <span class="title">Locked</span>
                          </b-link>
                          <b-link class="access_plan" v-else @click.stop.prevent="lockStreamClicked(advisee.adviseeSharedStreams[0])">
                            <span class="ic ico-unlock"></span>
                            <span class="title">Unlocked</span>
                          </b-link>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="!isAutomaticStreamShareTurnedOn">
                          <b-link class="view_plan"
                          <span class="icon-stream"></span>
                          <span class="title" style="cursor: pointer;" @click="requestAccessToPlanningStream(advisee)">Request Access</span>
                          </b-link>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- .row -->
            </div>
            <div v-if="advisees.length === 0 && !showLoader" class="no-result ace_sec_txt" aria-label="No Results Found">
              No Results Found
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ChannelUnreadCounterTag from '../../channel/components/ChannelUnreadCounterTag'

export default {
  name: 'instructor-advisee-tracker',
  props: ['isProspectiveStudent'],
  components: {
    ChannelUnreadCounterTag
  },
  data: () => {
    return {
      showLoader: false,
      name: '',
      lockStreamFlagName: 'lockStream',
      userReports: []
    }
  },

  mounted () {
    this.loadUpdatePageCount({page: 0, count: 20})
    this.loadAdviseeTracker()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadAdvisees',
      'loadUpdatePageCount',
      'loadLogDashboardActivity',
      'loadRequestAccessToPlanningStream',
      'lockStream',
      'unlockStream'
    ]),
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    async loadAdviseeTracker () {
      this.loadLogDashboardActivity({action: 'viewAdviseeTracker', page: 'adviseeTracker', link: ''})
      this.$refs.loadingModal.show()
      this.showLoader = true
      await this.loadAdvisees({name: this.name})
      this.showLoader = false
      this.$refs.loadingModal.hide()
    },
    clickNext () {
      this.loadUpdatePageCount({page: this.page + 1, count: this.count})
      this.loadAdviseeTracker({name: this.name})
    },
    clickPrev () {
      this.loadUpdatePageCount({page: this.page - 1, count: this.count})
      this.loadAdviseeTracker({name: this.name})
    },
    searchAdvisees () {
      this.loadUpdatePageCount({page: 0, count: 20})
      this.loadAdviseeTracker({name: this.name})
    },
    requestAccessToPlanningStream (advisee) {
      let adviseeName = advisee.userName
      this.$refs.loadingModal.show()
      this.loadRequestAccessToPlanningStream(advisee.userId).then(message => {
        this.$refs.loadingModal.hide()
        this.notifySuccess(message.replace('$$ADVISEE_NAME$$', adviseeName))
      })
    },
    async lockStreamClicked (stream) {
      let response = await this.lockStream(stream.uuid)
      if (!response) {
        this.notifyFailure('Unable to lock \'' + stream.title + '\'')
      }
      this.notifySuccess('Successfully locked \'' + stream.title + '\'')
      return this.loadAdviseeTracker()
    },
    async unlockStreamClicked (stream) {
      let response = await this.unlockStream(stream.uuid)
      if (!response) {
        this.notifyFailure('Failed to unlock \'' + stream.title + '\'')
      }
      this.notifySuccess('Successfully unlocked \'' + stream.title + '\'')
      return this.loadAdviseeTracker()
    },
    isLocked (stream) {
      if (!stream) {
        return false
      }
      return stream.locked || stream.isLocked
    },
    goToTimeView (uuid) {
      return this.$router.push({ name: 'streamTime', params: { uuid: uuid } })
    }
  },

  computed: {
    ...mapState({
      'advisees': state => state.adviseeTracker.advisees,
      'total': state => state.adviseeTracker.total,
      'count': state => state.adviseeTracker.count,
      'page': state => state.adviseeTracker.page,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    advisorDashboardFeature () {
      return this.enabledFeatures[PACKAGE.FEATURE_IDS.ADVISTOR_DASHBOARD_FEATURE_ID]
    },
    isChannelEnabled () {
      let channelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNELS_FEATURE_ID]
      if (channelFeature) {
        return channelFeature.enabled
      }
      return false
    },
    isCocuricularVerificationFeature () {
      if (this.enabledFeatures && this.enabledFeatures[PACKAGE.FEATURE_IDS.COCURICULAR_VERIFICATION_FEATURE_ID]) {
        return this.enabledFeatures[PACKAGE.FEATURE_IDS.COCURICULAR_VERIFICATION_FEATURE_ID].enabled
      }
      return false
    },
    showPrev () {
      if (this.page > 0) {
        return true
      } else {
        return false
      }
    },
    showNext () {
      let pg = this.page
      let cnt = this.count
      var res = (pg + 1) * cnt
      if (res <= this.total) {
        return true
      } else {
        return false
      }
    },
    start () {
      return (this.page * this.count) + ((this.advisees.length > 0) ? 1 : 0)
    },
    end () {
      return (this.page * this.count) + this.advisees.length
    },
    showStudentPopover () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showStudentPopover') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    redirectStreamToProgressView () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'redirectStreamToProgressView') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isAutomaticStreamShareTurnedOn () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'automaticStreamShare') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isLockStreamEnabled () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (!advisorDashboardFeature || !advisorDashboardFeature.enabled) {
        return false
      }
      let lockStreamFlag = PackageUtil.getFlagFromFeature(advisorDashboardFeature, this.lockStreamFlagName)
      if (!lockStreamFlag) {
        return false
      }
      return lockStreamFlag.enabled || lockStreamFlag.isEnabled
    },
    isShowStudentEmail () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showStudentEmail') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowStudentExternalId () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showStudentExternalId') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowProgramName () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showProgramNameWithLabel') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    majorLabel () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showProgramNameWithLabel') {
            return flags[i].label
          }
        }
      }
      return 'Program'
    }
  },

  watch: {
  }
}
</script>

<style lang="scss"
  src="../../../assets/module/sass/adviseeTracker/adviseeDetails.scss">
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/InstructorAdviseeTracker.vue